import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export const TextTo911Message = styled(Box).attrs({
  backgroundColor: 'foreground',
  marginX: 15,
  marginBottom: 15,
  padding: '6px 11px',
  borderRadius: 5,
  maxHeight: 280,
})``;

export const TextTo911MessageText = styled(Text).attrs({
  color: 'secondaryText',
  size: 'small',
})``;
